<template>
    <router-view></router-view>
</template>

<script>
// import {EventBus} from '../../services/eventBus'
export default {
    name: 'License',
    data: () => ({
    }),
    computed: {
    },
    props: [],
    watch: {
    },
    methods: {
    },
    created() {
    },
    beforeDestroy(){
    },
    mounted() {
    },
    components: {
    },
}
</script>